import React from "react";
import * as psdaAssets from "@tvet-mis/psda-assets";
import sidebarLogoCollapsed from "@assets/svg/sidebar-logo-collapsed.svg";
import { OptimizedSvg } from "@components/common/OptimizedSvg";

const assetsRecord = psdaAssets as unknown as Record<string, string>;
const sidebarLogoExpanded = assetsRecord.authCommonLogo || assetsRecord.applicationLogoV2;

interface SidebarLogoProps {
	isCollapsed?: boolean;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({ isCollapsed = false }) => (
	<div className="sidebar-header w-full">
		<div className="sidebar-branding flex w-full shrink-0 flex-col items-center text-center">
			<OptimizedSvg
				src={isCollapsed ? sidebarLogoCollapsed : sidebarLogoExpanded}
				alt="Skills Punjab"
				className={`sidebar-branding__logo [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-full ${
					isCollapsed ? "sidebar-branding__logo--collapsed" : "sidebar-branding__logo--expanded"
				}`}
				cacheKey={isCollapsed ? "sidebar-brand-logo-collapsed" : "sidebar-brand-logo-expanded"}
			/>
		</div>
	</div>
);

export default SidebarLogo;
